export function Logo({ width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 187 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.81983 118.686H3.18138V91.4007H8.36553L17.5645 112.605L26.7634 91.4007H31.9086V118.686H27.3091V100.249L19.3185 118.686H15.8104L7.81983 100.249V118.686ZM56.2619 95.2596H42.2686V102.938H52.7539V106.797H42.2686V114.827H56.2619V118.686H37.6302V91.4007H56.2619V95.2596ZM76.8609 99.6252C76.8609 98.2739 76.4581 97.2085 75.6525 96.4289C74.847 95.6493 73.5997 95.2596 71.9106 95.2596H65.8689V104.03H71.9106C73.054 104.03 73.9765 103.861 74.6781 103.523C75.4057 103.159 75.9514 102.652 76.3152 102.003C76.679 101.327 76.8609 100.535 76.8609 99.6252ZM71.9106 91.4007C74.0934 91.4007 75.8864 91.7775 77.2896 92.5311C78.7189 93.2587 79.7843 94.2591 80.4859 95.5324C81.1875 96.7797 81.5383 98.144 81.5383 99.6252C81.5383 100.613 81.3694 101.587 81.0316 102.549C80.6938 103.51 80.1481 104.407 79.3945 105.238C78.6409 106.044 77.6405 106.693 76.3931 107.187C75.1718 107.655 73.6776 107.889 71.9106 107.889H65.8689V118.686H61.2305V91.4007H71.9106ZM74.6781 106.368L82.123 118.686H76.8999L69.7278 106.368H74.6781ZM98.24 95.2596H96.8368L88.6513 118.686H83.8959L93.5626 91.4007H101.436L111.142 118.686H106.387L98.24 95.2596ZM89.197 108.2H105.1V112.02H89.197V108.2ZM113.32 91.4007H118.504L125.871 101.34L133.277 91.4007H138.422L128.521 105.043L138.422 118.686H133.277L125.871 108.746L118.504 118.686H113.32L123.259 105.043L113.32 91.4007ZM161.816 95.2596H147.823V102.938H158.308V106.797H147.823V114.827H161.816V118.686H143.184V91.4007H161.816V95.2596ZM169.903 111.202C170.059 111.929 170.358 112.592 170.799 113.19C171.267 113.761 171.878 114.216 172.631 114.554C173.411 114.892 174.334 115.061 175.399 115.061C177.036 115.061 178.257 114.684 179.063 113.93C179.869 113.151 180.271 112.241 180.271 111.202C180.271 110.344 180.011 109.63 179.492 109.058C178.998 108.486 178.296 108.006 177.387 107.616C176.477 107.2 175.438 106.81 174.269 106.446C173.203 106.135 172.177 105.81 171.189 105.472C170.202 105.108 169.305 104.666 168.5 104.147C167.72 103.601 167.097 102.912 166.629 102.081C166.161 101.223 165.94 100.158 165.966 98.8846C165.966 97.2215 166.356 95.8183 167.136 94.6749C167.915 93.5055 169.006 92.622 170.41 92.0243C171.813 91.4267 173.424 91.1278 175.243 91.1278C176.776 91.1278 178.153 91.3487 179.375 91.7905C180.622 92.2062 181.675 92.8299 182.532 93.6614C183.39 94.467 184.026 95.4674 184.442 96.6628L180.193 98.066C180.037 97.4943 179.726 96.9876 179.258 96.5459C178.79 96.0781 178.205 95.7143 177.504 95.4545C176.828 95.1946 176.088 95.0517 175.282 95.0257C174.399 94.9997 173.606 95.1296 172.904 95.4155C172.229 95.7013 171.683 96.1171 171.267 96.6628C170.851 97.1825 170.644 97.7932 170.644 98.4948C170.644 99.3003 170.877 99.937 171.345 100.405C171.813 100.846 172.424 101.223 173.177 101.535C173.957 101.821 174.814 102.12 175.75 102.432C176.841 102.743 177.92 103.107 178.985 103.523C180.076 103.913 181.064 104.42 181.947 105.043C182.857 105.641 183.584 106.407 184.13 107.343C184.676 108.278 184.949 109.448 184.949 110.851C184.949 112.358 184.598 113.722 183.896 114.944C183.221 116.165 182.181 117.14 180.778 117.867C179.375 118.595 177.634 118.959 175.555 118.959C173.866 118.959 172.32 118.712 170.916 118.218C169.539 117.698 168.383 116.971 167.447 116.035C166.538 115.074 165.94 113.943 165.654 112.644L169.903 111.202Z"
        fill="black"
      />
      <path
        d="M161.505 72.6226C162.527 74.4263 161.225 76.6623 159.151 76.6623H133.618C133.493 76.6623 133.372 76.6039 133.31 76.4952C127.943 67.3739 122.653 58.2021 117.484 48.9681C116.482 47.1804 115.331 46.613 113.373 46.648C107.986 46.7451 102.6 46.648 97.2131 46.6285C95.6127 46.6285 94.6106 44.8982 95.4068 43.51C103.016 30.2435 110.427 17.3205 118.002 4.11726C119.045 2.2991 121.67 2.3065 122.704 4.13037C135.736 27.1403 148.556 49.7674 161.505 72.6226Z"
        fill="url(#paint0_linear_18_4170)"
      />
      <path
        d="M127.137 72.6255C128.155 74.4298 126.851 76.6627 124.78 76.6627H81.1334C79.0578 76.6627 77.755 74.4218 78.7817 72.6178C80.3413 69.8773 81.8363 67.2511 83.3349 64.6267C85.8261 60.2662 88.3833 55.9484 90.7928 51.5452C91.4457 50.3443 92.223 49.8274 93.42 49.7264C93.6143 49.7069 93.8164 49.6992 94.034 49.7031C100.062 49.7886 106.09 49.6797 112.113 49.8158C113.093 49.8391 114.492 50.4726 114.95 51.2615C119.081 58.3411 123.109 65.4841 127.137 72.6255Z"
        fill="url(#paint1_linear_18_4170)"
      />
      <path
        d="M91.433 43.5103C92.2293 44.8983 91.2274 46.6285 89.6272 46.6285C84.2407 46.648 78.8503 46.7451 73.4677 46.648C71.509 46.613 70.3586 47.1804 69.3559 48.9681C64.1871 58.2021 58.8977 67.3739 53.5307 76.4952C53.4686 76.6039 53.3476 76.6623 53.2224 76.6623H27.6883C25.6153 76.6623 24.3124 74.4266 25.3341 72.6229C38.2805 49.7676 51.1037 27.1404 64.1367 4.13036C65.1698 2.30649 67.7952 2.29911 68.8382 4.1173C76.4124 17.3207 83.8216 30.2437 91.433 43.5103Z"
        fill="url(#paint2_linear_18_4170)"
      />
      <path
        d="M108.058 72.6178C109.085 74.4218 107.782 76.6627 105.707 76.6627H62.0602C59.9887 76.6627 58.6851 74.4297 59.7027 72.6254C63.7301 65.484 67.7556 58.3411 71.8856 51.2615C72.3442 50.4726 73.7472 49.8391 74.7266 49.8158C80.7504 49.6797 86.7782 49.7886 92.802 49.7031C93.0197 49.6992 93.2256 49.7069 93.42 49.7264C94.617 49.8313 95.3903 50.3443 96.0471 51.5452C98.4567 55.9484 101.014 60.2662 103.505 64.6267C105.004 67.2511 106.499 69.8773 108.058 72.6178Z"
        fill="url(#paint3_linear_18_4170)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_18_4170"
          x1="128.706"
          y1="0"
          x2="128.706"
          y2="76.6623"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#76B6DB" />
          <stop offset="1" stop-color="#1E3A8A" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_18_4170"
          x1="102.947"
          y1="49.7021"
          x2="102.947"
          y2="76.6627"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#76B6DB" />
          <stop offset="1" stop-color="#1E3A8A" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_18_4170"
          x1="58.1341"
          y1="0"
          x2="58.1341"
          y2="76.6623"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#76B6DB" />
          <stop offset="1" stop-color="#1E3A8A" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_18_4170"
          x1="83.8925"
          y1="49.7021"
          x2="83.8925"
          y2="76.6627"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#76B6DB" />
          <stop offset="1" stop-color="#1E3A8A" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function DashboardIcon() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="8.52632" height="8.52632" rx="2" fill="#A8A8A8" />
      <rect
        y="10.4737"
        width="8.52632"
        height="8.52632"
        rx="2"
        fill="#A8A8A8"
      />
      <rect
        x="10.4736"
        width="8.52632"
        height="8.52632"
        rx="2"
        fill="#A8A8A8"
      />
      <rect
        x="10.4736"
        y="10.4736"
        width="8.52632"
        height="8.52632"
        rx="2"
        fill="#A8A8A8"
      />
    </svg>
  );
}

export function Staff() {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1615 15.1286C16.1615 15.6867 16.157 16.2448 16.1645 16.8028C16.1666 16.9481 16.1211 17.0301 15.9865 17.0909C15.1519 17.4693 14.274 17.6911 13.3721 17.8291C12.516 17.9604 11.6541 18.0178 10.7898 17.9952C9.96655 17.9737 9.14327 17.9098 8.33708 17.7362C7.45571 17.5461 6.58254 17.3175 5.7056 17.1077C5.56822 17.0749 5.51388 17.0034 5.51491 16.8558C5.52072 15.8822 5.50978 14.9082 5.52003 13.9342C5.53029 12.9653 5.77908 12.0686 6.39799 11.302C7.06201 10.4794 7.91775 9.98048 8.96624 9.82362C9.13985 9.79764 9.31722 9.78842 9.49322 9.78773C10.4214 9.78466 11.3496 9.78056 12.2778 9.78944C13.0983 9.7973 13.8406 10.055 14.5053 10.5348C15.3611 11.1527 15.8826 11.9913 16.102 13.0142C16.1621 13.2944 16.1536 13.5911 16.1597 13.8809C16.1686 14.2964 16.1621 14.7124 16.1618 15.1279L16.1615 15.1286Z"
        fill="#A8A8A8"
      />
      <path
        d="M8.06903 9.17361C7.76795 9.31544 7.46824 9.43642 7.18732 9.59191C6.32782 10.068 5.68362 10.7508 5.23661 11.6298C4.89349 12.3037 4.75098 13.0193 4.72159 13.764C4.71099 14.0309 4.72501 14.2988 4.73423 14.5661C4.73833 14.6884 4.68536 14.7288 4.57019 14.7182C3.71103 14.6368 2.85358 14.5408 2.0139 14.3361C1.38576 14.183 0.763435 14.006 0.137006 13.8457C0.0396072 13.8207 0.0115837 13.7777 0.0119254 13.682C0.0146594 12.5204 -0.0263506 11.3567 0.0296965 10.1978C0.059087 9.5861 0.277124 8.99112 0.614773 8.45764C1.22343 7.49596 2.08362 6.88798 3.18815 6.63236C3.44071 6.57392 3.70625 6.54999 3.96632 6.54726C4.88289 6.53735 5.79981 6.54282 6.71639 6.5435C6.95083 6.5435 6.93682 6.54692 6.96074 6.78033C7.03626 7.52022 7.29189 8.19245 7.75086 8.78231C7.85476 8.91559 7.96378 9.04443 8.06938 9.17395L8.06903 9.17361Z"
        fill="#A8A8A8"
      />
      <path
        d="M13.6584 9.16234C13.8105 8.95934 13.9837 8.74882 14.1348 8.52326C14.5025 7.97304 14.7093 7.36507 14.7428 6.70276C14.7486 6.58861 14.7821 6.54043 14.9027 6.54077C15.7629 6.54453 16.6245 6.51001 17.4826 6.55034C19.0861 6.62552 20.262 7.40471 20.9749 8.84143C21.141 9.17635 21.1967 9.56492 21.3146 9.92512C21.4315 10.2816 21.372 10.6459 21.3758 11.0061C21.3854 11.8663 21.3768 12.7265 21.382 13.5863C21.3826 13.7062 21.344 13.7657 21.235 13.8187C20.5286 14.1601 19.7836 14.3815 19.0133 14.508C18.4487 14.6006 17.8776 14.6594 17.308 14.7168C16.9659 14.7513 16.9645 14.7373 16.9652 14.3874C16.9662 13.779 16.9905 13.1704 16.8271 12.5733C16.5045 11.3943 15.8528 10.4483 14.8258 9.78261C14.4574 9.54373 14.0483 9.36739 13.6577 9.16268L13.6584 9.16234Z"
        fill="#A8A8A8"
      />
      <path
        d="M10.8536 3.29517C12.5497 3.29175 13.9966 4.68165 13.958 6.46525C13.9215 8.1617 12.5582 9.52255 10.8436 9.50546C9.0498 9.48769 7.75867 8.10907 7.74739 6.41125C7.73543 4.65363 9.1513 3.29996 10.8539 3.29517H10.8536Z"
        fill="#A8A8A8"
      />
      <path
        d="M5.38076 0.0485286C6.72349 0.0755268 7.93978 0.950066 8.31776 2.28529C8.39875 2.57201 8.42131 2.87651 8.45514 3.17452C8.46232 3.23945 8.42131 3.33446 8.37005 3.37786C7.65613 3.98515 7.1934 4.73734 7.01808 5.66349C7.00544 5.73047 6.9429 5.80531 6.88275 5.84325C6.40772 6.14125 5.87663 6.27146 5.32642 6.26668C4.50485 6.25916 3.78512 5.9632 3.19013 5.38701C2.7233 4.93488 2.4188 4.38773 2.29851 3.75105C2.15292 2.97972 2.27664 2.24325 2.68332 1.56863C3.05617 0.950408 3.58007 0.491437 4.26596 0.256313C4.62139 0.134308 5.00141 0.0833871 5.37016 0C5.37392 0.0160623 5.37734 0.0324663 5.3811 0.0485286H5.38076Z"
        fill="#A8A8A8"
      />
      <path
        d="M15.9174 0.0488892C17.3742 0.0488892 18.584 0.946326 18.9924 2.18756C19.4921 3.70596 18.7563 5.31595 17.3667 5.96698C16.5421 6.3535 15.6993 6.36649 14.8579 6.01961C14.7899 5.99159 14.7291 5.87778 14.7158 5.79542C14.5343 4.69362 13.9824 3.82865 13.0713 3.18958C12.9824 3.12704 12.9417 3.06347 12.9517 2.93805C13.0296 1.96235 13.4786 1.19751 14.2588 0.626447C14.7923 0.235827 15.403 0.0574329 15.9174 0.0492309V0.0488892Z"
        fill="#A8A8A8"
      />
    </svg>
  );
}

export function Patient() {
  return (
    <svg
      width="16"
      height="21"
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2533 6.125C12.8284 8.60388 10.6382 10.5 8 10.5C5.36178 10.5 3.17244 8.60388 2.74667 6.125H13.2533ZM13.2587 4.375C13.1102 3.51837 12.7493 2.73263 12.2329 2.0685L8.75556 4.375H13.2587ZM5.73511 4.375L10.9182 0.861C10.0791 0.3185 9.07644 0 8 0C5.36267 0 3.17244 1.89613 2.74667 4.375H5.73511ZM12 12.25H8.10667L9.52889 17.5H12.4444V21H16V16.1875C16 14.0166 14.2053 12.25 12 12.25ZM4 12.25H6.12889L8 19.25H10.6667V21H2.66667C1.19644 21 0 19.8223 0 18.375V16.1875C0 14.0166 1.79467 12.25 4 12.25Z"
        fill="#A8A8A8"
      />
    </svg>
  );
}

export function Task() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 5.25V6H0V5.25C0 3.17925 1.67925 1.5 3.75 1.5H4.5V0.75C4.5 0.336 4.836 0 5.25 0C5.664 0 6 0.336 6 0.75V1.5H12V0.75C12 0.336 12.336 0 12.75 0C13.164 0 13.5 0.336 13.5 0.75V1.5H14.25C16.3207 1.5 18 3.17925 18 5.25ZM18 12.75C18 15.645 15.6442 18 12.75 18C9.85575 18 7.5 15.645 7.5 12.75C7.5 9.855 9.85575 7.5 12.75 7.5C15.6442 7.5 18 9.855 18 12.75ZM14.25 13.1895L13.5 12.4395V11.25C13.5 10.836 13.164 10.5 12.75 10.5C12.336 10.5 12 10.836 12 11.25V12.75C12 12.9487 12.0787 13.14 12.2197 13.2803L13.1895 14.25C13.482 14.5425 13.9575 14.5425 14.25 14.25C14.5425 13.9575 14.5425 13.482 14.25 13.1895ZM6 12.75C6 10.6283 6.981 8.7375 8.51175 7.5H0V14.25C0 16.3207 1.67925 18 3.75 18H8.51175C6.981 16.7625 6 14.8717 6 12.75Z"
        fill="#A8A8A8"
      />
    </svg>
  );
}

export function Appointment() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 0C4.26154 0 0 4.26154 0 9.5C0 14.7385 4.26154 19 9.5 19C14.7385 19 19 14.7385 19 9.5C19 4.26154 14.7385 0 9.5 0ZM12.6667 10.2917H9.5C9.063 10.2917 8.70833 9.93779 8.70833 9.5V4.75C8.70833 4.31221 9.063 3.95833 9.5 3.95833C9.937 3.95833 10.2917 4.31221 10.2917 4.75V8.70833H12.6667C13.1045 8.70833 13.4583 9.06221 13.4583 9.5C13.4583 9.93779 13.1045 10.2917 12.6667 10.2917Z"
        fill="#A8A8A8"
      />
    </svg>
  );
}

export function Billing() {
  return (
    <svg
      width="15"
      height="19"
      viewBox="0 0 15 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.33333 0C3.2839 0.00125705 2.27782 0.418698 1.53576 1.16076C0.793698 1.90282 0.376257 2.9089 0.375 3.95833V18.2083C0.375112 18.3523 0.414493 18.4936 0.488906 18.6168C0.563319 18.7401 0.669945 18.8408 0.797305 18.9079C0.924665 18.9751 1.06794 19.0063 1.2117 18.9981C1.35546 18.9899 1.49426 18.9427 1.61317 18.8615L3.28042 17.7222L4.94767 18.8615C5.07939 18.9517 5.23531 18.9999 5.39496 18.9999C5.55461 18.9999 5.71053 18.9517 5.84225 18.8615L7.50475 17.7222L9.16725 18.8615C9.29906 18.9518 9.45513 19.0002 9.61494 19.0002C9.77475 19.0002 9.93082 18.9518 10.0626 18.8615L11.7251 17.723L13.3876 18.8607C13.5065 18.9416 13.6451 18.9887 13.7887 18.9968C13.9323 19.0049 14.0753 18.9738 14.2025 18.9067C14.3297 18.8396 14.4363 18.7392 14.5107 18.6162C14.5851 18.4931 14.6246 18.3521 14.625 18.2083V3.95833C14.6237 2.9089 14.2063 1.90282 13.4642 1.16076C12.7222 0.418698 11.7161 0.00125705 10.6667 0L4.33333 0ZM9.08333 11.0833H4.33333C4.12337 11.0833 3.92201 10.9999 3.77354 10.8515C3.62507 10.703 3.54167 10.5016 3.54167 10.2917C3.54167 10.0817 3.62507 9.88034 3.77354 9.73187C3.92201 9.58341 4.12337 9.5 4.33333 9.5H9.08333C9.2933 9.5 9.49466 9.58341 9.64313 9.73187C9.79159 9.88034 9.875 10.0817 9.875 10.2917C9.875 10.5016 9.79159 10.703 9.64313 10.8515C9.49466 10.9999 9.2933 11.0833 9.08333 11.0833ZM11.4583 7.125C11.4583 7.33496 11.3749 7.53633 11.2265 7.68479C11.078 7.83326 10.8766 7.91667 10.6667 7.91667H4.33333C4.12337 7.91667 3.92201 7.83326 3.77354 7.68479C3.62507 7.53633 3.54167 7.33496 3.54167 7.125C3.54167 6.91504 3.62507 6.71367 3.77354 6.56521C3.92201 6.41674 4.12337 6.33333 4.33333 6.33333H10.6667C10.8766 6.33333 11.078 6.41674 11.2265 6.56521C11.3749 6.71367 11.4583 6.91504 11.4583 7.125Z"
        fill="#A8A8A8"
      />
    </svg>
  );
}

export function Setting() {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9905 10.4561C20.9962 9.3048 20.559 7.91486 18.5361 7.54446C18.4311 7.34399 18.3156 7.14256 18.1887 6.94018C19.2082 5.52828 19.1299 4.21852 17.9519 3.0405C16.7729 1.86058 15.4632 1.78325 14.0503 2.80662C13.8508 2.68061 13.6513 2.56605 13.4518 2.46295C13.0871 0.446768 11.7105 0 10.5621 0C8.95164 0 7.91682 0.850577 7.61611 2.50495C7.41755 2.60901 7.21707 2.72452 7.01565 2.85053C5.60947 1.8348 4.29876 1.92167 3.10834 3.11019C1.92173 4.29775 1.83581 5.60942 2.84868 7.01559C2.72171 7.21797 2.60525 7.4194 2.49928 7.61987C0.848723 7.92154 0.00864693 8.90385 5.52447e-05 10.5439C-0.00567255 11.6952 0.431549 13.0851 2.45441 13.4555C2.55942 13.656 2.67493 13.8574 2.80286 14.0598C1.78235 15.4717 1.86063 16.7815 3.03865 17.9595C4.21762 19.1394 5.52833 19.2167 6.94023 18.1934C7.13975 18.3194 7.33927 18.4339 7.53878 18.537C7.90345 20.5532 9.28004 21 10.4285 21C12.1325 21 13.0737 20.1494 13.3745 18.495C13.573 18.391 13.7735 18.2755 13.9749 18.1495C16.2193 19.8382 17.8813 17.8898 17.8822 17.8898C19.0411 16.7929 19.1557 15.3906 18.1419 13.9835C18.2689 13.7811 18.3853 13.5796 18.4913 13.3801C20.1418 13.0785 20.9819 12.0961 20.9905 10.4561ZM12.8456 12.8503C12.0657 13.6312 11.3249 14.0665 10.2967 14.0054C9.32681 13.9472 8.60415 13.3104 8.14498 12.8503C6.58511 11.2914 6.58511 9.70861 8.14498 8.14874C8.98696 7.30484 9.8194 6.92108 10.6938 6.99459C11.6628 7.06905 12.3864 7.68956 12.8456 8.14969C14.4045 9.70861 14.4055 11.2914 12.8456 12.8513V12.8503Z"
        fill="#A8A8A8"
      />
    </svg>
  );
}

export function NotiFicationIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="39"
        height="39"
        rx="11.5"
        fill="white"
        stroke="#E8E8E8"
      />
    </svg>
  );
}

export function EditIcon() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.1581 0.842302C17.6179 0.302941 16.8858 0 16.1224 0C15.3591 0 14.627 0.302941 14.0868 0.842302L1.16404 13.7653C0.793978 14.1333 0.500555 14.571 0.300752 15.0532C0.100948 15.5353 -0.00126969 16.0522 1.19035e-05 16.5741V18.2054C1.19035e-05 18.4161 0.0837243 18.6182 0.232733 18.7673C0.381743 18.9163 0.583842 19 0.794573 19H2.42581C2.94764 19.0015 3.46459 18.8994 3.94672 18.6997C4.42885 18.5001 4.86658 18.2067 5.23458 17.8367L18.1581 4.91292C18.6972 4.37276 19 3.64078 19 2.87761C19 2.11445 18.6972 1.38246 18.1581 0.842302ZM4.11107 16.7132C3.66294 17.1584 3.05745 17.409 2.42581 17.4108H1.58913V16.5741C1.58833 16.261 1.64964 15.9508 1.76953 15.6615C1.88941 15.3722 2.06549 15.1096 2.28755 14.8888L12.0948 5.08137L13.9223 6.9089L4.11107 16.7132ZM17.0338 3.78939L15.0426 5.78139L13.2151 3.95784L15.2071 1.96583C15.3271 1.8461 15.4695 1.75117 15.6262 1.68647C15.7829 1.62177 15.9508 1.58856 16.1203 1.58875C16.2898 1.58893 16.4576 1.6225 16.6141 1.68754C16.7707 1.75259 16.9129 1.84782 17.0326 1.96782C17.1524 2.08782 17.2473 2.23022 17.312 2.38691C17.3767 2.54359 17.4099 2.71149 17.4097 2.881C17.4095 3.05052 17.3759 3.21834 17.3109 3.37488C17.2459 3.53143 17.1506 3.67363 17.0306 3.79336L17.0338 3.78939Z"
        fill="black"
      />
    </svg>
  );
}
export function DropDownLocationIcon() {
  return (
    <svg
      width="13"
      height="17"
      viewBox="0 0 13 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.38071 10.8449C7.1098 10.8449 7.76728 10.6659 8.35316 10.3079C8.93904 9.94981 9.40123 9.47786 9.73974 8.89198C9.28405 8.51442 8.76978 8.22473 8.19693 8.02293C7.62407 7.82113 7.01866 7.72023 6.38071 7.72023C5.74275 7.72023 5.13734 7.82113 4.56449 8.02293C3.99163 8.22473 3.47736 8.51442 3.02168 8.89198C3.36018 9.47786 3.82238 9.94981 4.40825 10.3079C4.99413 10.6659 5.65161 10.8449 6.38071 10.8449ZM6.38071 6.93906C6.81035 6.93906 7.17815 6.78608 7.48411 6.48012C7.79007 6.17416 7.94305 5.80636 7.94305 5.37672C7.94305 4.94707 7.79007 4.57927 7.48411 4.27331C7.17815 3.96736 6.81035 3.81438 6.38071 3.81438C5.95106 3.81438 5.58326 3.96736 5.2773 4.27331C4.97135 4.57927 4.81837 4.94707 4.81837 5.37672C4.81837 5.80636 4.97135 6.17416 5.2773 6.48012C5.58326 6.78608 5.95106 6.93906 6.38071 6.93906ZM6.38071 16.3131C4.28457 14.5294 2.71897 12.8727 1.68392 11.3429C0.648873 9.81311 0.131348 8.39724 0.131348 7.09529C0.131348 5.14236 0.759538 3.58654 2.01592 2.4278C3.2723 1.26906 4.72723 0.689697 6.38071 0.689697C8.03418 0.689697 9.48911 1.26906 10.7455 2.4278C12.0019 3.58654 12.6301 5.14236 12.6301 7.09529C12.6301 8.39724 12.1125 9.81311 11.0775 11.3429C10.0424 12.8727 8.47685 14.5294 6.38071 16.3131Z"
        fill="white"
      />
    </svg>
  );
}
export function PlusIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 9.65581V14.2884H14.2884V24H9.65581V14.2884H0V9.65581H9.65581V0H14.2884V9.65581H24Z"
        fill="#1A1A1A"
      />
    </svg>
  );
}

export function PDFIcon() {
  return (
    <svg
      width="38"
      height="47"
      viewBox="0 0 38 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <rect width="38" height="47" fill="url(#pattern0_125_6337)" />
      <defs>
        <pattern
          id="pattern0_125_6337"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            // xlink:href="#image0_125_6337"
            transform="matrix(0.00160838 0 0 0.00130039 -0.00261789 0)"
          />
        </pattern>
        <image id="image0_125_6337" width="625" height="769" />
      </defs>
    </svg>
  );
}

export function CrossIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0775 1.07352C13.8762 0.872311 13.6033 0.759277 13.3187 0.759277C13.0341 0.759277 12.7611 0.872311 12.5599 1.07352L7.63777 5.99563L2.71566 1.07352C2.51439 0.872311 2.24145 0.759277 1.95685 0.759277C1.67225 0.759277 1.39931 0.872311 1.19803 1.07352C0.996823 1.27479 0.883789 1.54774 0.883789 1.83234C0.883789 2.11693 0.996823 2.38988 1.19803 2.59115L6.12014 7.51326L1.19803 12.4354C0.996823 12.6366 0.883789 12.9096 0.883789 13.1942C0.883789 13.4788 0.996823 13.7517 1.19803 13.953C1.39931 14.1542 1.67225 14.2672 1.95685 14.2672C2.24145 14.2672 2.51439 14.1542 2.71566 13.953L7.63777 9.03089L12.5599 13.953C12.7611 14.1542 13.0341 14.2672 13.3187 14.2672C13.6033 14.2672 13.8762 14.1542 14.0775 13.953C14.2787 13.7517 14.3917 13.4788 14.3917 13.1942C14.3917 12.9096 14.2787 12.6366 14.0775 12.4354L9.1554 7.51326L14.0775 2.59115C14.2787 2.38988 14.3917 2.11693 14.3917 1.83234C14.3917 1.54774 14.2787 1.27479 14.0775 1.07352Z"
        fill="black"
      />
    </svg>
  );
}
